<template>
  <div class="my-5 pt-md-4">
    <div class="border px-3 py-4 rounded bg-light">
      <h5 class="font-weight-bolder kova-text">Connect with Talents</h5>
      <div class="alert alert-success" v-if="message">
        <strong>{{ message }}</strong>
      </div>
      <p class="text-danger font-weight-bolder my-2" v-if="error">
        {{ error }}
      </p>
      <div class>
        <a-input
          class="mt-3 w-100"
          v-model="email"
          size="large"
          placeholder="Work Email"
          ref="searchInput"
        ></a-input>
      </div>
      <div class>
        <a-input
          class="mt-3 w-100"
          size="large"
          v-model="password"
          type="password"
          placeholder="Password"
          minlength="8"
          ref="searchInput"
        ></a-input>
      </div>
      <div class>
        <a-input
          class="mt-3 w-100"
          v-model="confirmPassword"
          size="large"
          type="password"
          minlength="8"
          placeholder="Confirm Password"
          ref="searchInput"
        ></a-input>
      </div>
      <button
        class="btn-kovatek px-5 py-2 mt-4 add-rounded"
        style="width: 100%;"
        @click.prevent="signup"
      >
        Sign Up
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "signup",
  data() {
    return {
      showDevs: false,
      category: "",
      experienceLevel: "",
      skill: "",
      locate: "",
      message: "",
      employer: true,
      devs: false,
      email: "",
      password: "",
      confirmPassword: "",
      usertype: 2,
      htmlForEditor: "",
      error: null
    };
  },
  methods: {
    signup() {
      this.employer
        ? (this.usertype = 2)
        : this.devs
        ? (this.usertype = 1)
        : (this.usertype = "");
      const isValid =
        this.password !== this.confirmPassword ||
        this.email === "" ||
        this.password === "" ||
        this.confirmPassword === "" ||
        this.usertype === "";

      // console.log(isValid)
      if (!isValid) {
        if (this.password.length < 8) {
          this.error = "Password must be 8 chars or more";
        } else if (this.confirmPassword.length < 8) {
          this.error = "Password must be 8 chars or more";
        } else {
          const data = {
            email: this.email,
            password: this.password,
            user_type: this.usertype
          };

          // console.log(data)

          this.$store
            .dispatch("signup", data)
            .then(() => {
              this.message = "Signup Successful";
              window.location.href = "http://client.kovatek.com/hire-talent";
            })
            .catch(err => {
              /*    console.log(err); */
              if (err == "Error: Request failed with status code 409") {
                this.error = "Oops! User already exists";
              } else {
                this.error = err;
              }
            });
        }
      } else {
        this.error = "invalid or incomplete inputs";
      }
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.width = window.innerWidth;
    });
  }
};
</script>

<style scoped></style>
